/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Search_Value_PercentInputs */

const en_us2_search_value_percent = /** @type {(inputs: Search_Value_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}%`)
};

const pt_br2_search_value_percent = /** @type {(inputs: Search_Value_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}%`)
};

const es_419_search_value_percent = /** @type {(inputs: Search_Value_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}%`)
};

const pt_pt2_search_value_percent = /** @type {(inputs: Search_Value_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}%`)
};

const fr_fr2_search_value_percent = /** @type {(inputs: Search_Value_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} %`)
};

const de_de2_search_value_percent = /** @type {(inputs: Search_Value_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} %`)
};

const it_it2_search_value_percent = /** @type {(inputs: Search_Value_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}%`)
};

/**
* | output |
* | --- |
* | "{value}%" |
*
* @param {Search_Value_PercentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_value_percent = /** @type {((inputs: Search_Value_PercentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Value_PercentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_value_percent(inputs)
	if (locale === "es-419") return es_419_search_value_percent(inputs)
	if (locale === "pt-PT") return pt_pt2_search_value_percent(inputs)
	if (locale === "fr-FR") return fr_fr2_search_value_percent(inputs)
	if (locale === "de-DE") return de_de2_search_value_percent(inputs)
	if (locale === "it-IT") return it_it2_search_value_percent(inputs)
	return en_us2_search_value_percent(inputs)
});
export { search_value_percent as "search.value_percent" }